import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import { HttpStatusCode } from "axios";

import {
  SERVICE_DETAIL_ITEM_TYPE,
  SERVICE_TEMPLATE_ID,
} from "../../consts/serviceTemplate";
import { MANAGER_ROLE } from "../../consts/member";

import { CATEGORY, CATEGORY_ALIAS } from "../../types/talk";
import { MemberShipCardInfo } from "../../types/memberShipCardTypes";
import { BuildingInfo } from "../../types/member";

import { getLocalValue } from "../../libs/localStorage";
import {
  getServiceNameWithNewLine,
  replaceMemberShipName,
} from "../../libs/replace";
import { getBuildingKey, getBuildingLabel } from "../../libs/building";
import { findCategoryForContext } from "../../libs/category";
import { isArrayEmpty } from "../../libs/common";

import { useUserContext } from "../../contexts/userContext";
import { useSandiTalk } from "../../contexts/boardContext";

import {
  getManagerNotice,
  getTalkCategories,
  getTalkPostList,
  TalkCategory,
  TalkListItem,
} from "../../services/talkServices";
import {
  getTotalService,
  searchService,
  UserServiceResponse,
} from "../../services/userServiceServices";
import { BannerItem, getBanner } from "../../services/bannerServices";
import {
  getMemberSpaceList,
  SpaceItem,
  updateMemberSpace,
} from "../../services/memberServices";
import { getToiletMonitoringInfo } from "../../services/iotServices";
import {
  getMemberShipInfo,
  navigateSmartOliveState,
} from "../../services/memberShipCardServices";
import { getOpenCount, isCleaning } from "../Services/ToiletEmpty";

import useNavigateService from "../../hooks/useNavigateService";
import useSimplePopup from "../../hooks/useSimplePopup";
import useFullScreenLoading from "../../hooks/useFullScreenLoading";

import MainBanner from "../../components/Swiper/MainBanner";
import Badge from "../../components/Badge";
import HorizontalRule from "../../components/Rule/Horizontal";
import VerticalRule from "../../components/Rule/Vertical";
import PostSwiper from "../../components/Swiper/Post";
import CommonButton from "../../components/Button";
import { Skeleton } from "../Talk";
import OnBoard from "../../components/OnBoard";
import ServiceBadge from "../../components/Badge/Service";
import CommonSelect, { SelectOption } from "../../components/Select";
import DefaultBanner from "../../components/Banner";

import RingNotificationIcon from "../../svgs/icons/RingNotificationIcon";
import ZoomSearchIcon from "../../svgs/icons/ZoomSearchIcon";
import PlusIcon from "../../svgs/icons/PlusIcon";
import { NoDataIcon } from "../Center";
import MemberShipCardCI from "../../assets/img/member-ship-card.png";
import CafeteriaCI from "../../assets/img/cafeteria.png";
import Isms from "../../components/Isms";

type ServiceObject = {
  service?: UserServiceResponse[];
  manager?: UserServiceResponse[];
};

type Props = {};

// eslint-disable-next-line no-empty-pattern
export default function View(props: Props) {
  const navigate = useNavigate();
  const [user, { updateField }] = useUserContext();
  const [talk, { updateField: updateTalkField, updateCategory }] =
    useSandiTalk();
  const [activeMainBannerIndex, setActiveMainBannerIndex] = React.useState(0);
  const [selectedSandiTalkCategory, setSelectedSandiTalkCategory] =
    React.useState("인기글");
  const [postList, setPostList] = useState<TalkListItem[]>([]);
  const [activeServiceTab, setActiveServiceTab] = useState("service");
  const [services, setServices] = useState<ServiceObject>({});
  const [mainRollBanner, setMainRollBanner] = useState<BannerItem[]>([]);
  const [mainFixBanner, setMainFixBanner] = useState<BannerItem[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isLoadingService, setIsLoadingService] = useState<boolean>(false);
  const loadingComponent = useFullScreenLoading({
    isLoading: isLoading || (user?.isLoading ?? false),
  });
  const [noticePost, setNoticePost] = useState<TalkListItem>();
  const [buildingNoticePost, setBuildingNoticePost] = useState<TalkListItem>();
  const [memberSpaceList, setMemberSpaceList] = useState<SpaceItem[]>([]);
  const boarded = getLocalValue("boarded");
  const [isPostLoading, setIsPostLoading] = useState<boolean>(false);
  const [toiletIsCleaning, setToiletIsCleaning] = useState<boolean>(false);
  const [toiletRate, setToiletRate] = useState<number>(0);
  const [totalToiletCount, setTotalToiletCount] = useState<number>(0);
  const [supportToilet, setSupportToilet] = useState<boolean>(false);
  const [isBannerLoading, setIsBannerLoading] = useState<boolean>(true);
  const [simplePopupComponent, { open, openError }] = useSimplePopup({});
  const [selectedBuilding, setSelectedBuilding] = useState<
    Partial<BuildingInfo>
  >({
    buildingId: user.buildingId,
    buildingName: user.buildingName,
    buildingFloorId: user.buildingFloorId,
    buildingFloorName: user.buildingFloorName,
    buildingSpaceId: user.buildingSpaceId,
    buildingSpaceName: user.buildingSpaceName,
  });
  const [buildingCategoryList, setBuildingCategoryList] = useState<
    TalkCategory[]
  >([]);
  const [memberShip, setMemberShip] = useState<Partial<MemberShipCardInfo>>({});
  const [memberShipService, setMemberShipService] = useState<
    UserServiceResponse | undefined
  >(undefined);

  const sandiTalkCategoryList = [
    {
      name: "인기글",
      url: `pinelife/post/list?category=${CATEGORY_ALIAS.TALK}&viewType=ALL_DEEP&sort=viewCount.desc&dateRange=7&pageSize=10`,
    },
    {
      name: "이벤트",
      url: `pinelife/post/list?category=${CATEGORY_ALIAS.TALK_SANDI_EVENT}&viewType=BASIC&sort=createdAt.desc&pageSize=10`,
    },
    {
      name: "공지",
      url: `pinelife/post/list?category=${CATEGORY_ALIAS.BUILDING_NOTICE}&viewType=BASIC&sort=createdAt.desc&pageSize=10`,
    },
  ];

  const [handleNavigateService, navigateServiceComponent] = useNavigateService({
    buildingCategoryList,
    activeServiceTab,
  });

  const isSmartOlive = (serviceDetailType: string | undefined) => {
    return serviceDetailType === SERVICE_DETAIL_ITEM_TYPE.SMART_OLIVE;
  };

  const updateCategoryFromLocation = async (categoryId: number) => {
    const categoryInfo = findCategoryForContext(
      talk?.categoryList ?? [],
      "lifeCategoryId",
      categoryId,
      0
    );
    if (categoryInfo) {
      await updateCategory({
        categoryInfo: categoryInfo,
      });
    } else {
      console.log("categoryInfo is null");
    }
  };

  const handleNavigateSmartOlive = () => {
    navigate("/service/custom", {
      state: { iframeUrl: memberShip.url, ...navigateSmartOliveState },
    });
  };

  const loadPostList = async () => {
    setIsPostLoading(true);
    let url = sandiTalkCategoryList.find(
      (item) => item.name === selectedSandiTalkCategory
    )?.url as string;

    if (url?.includes(CATEGORY_ALIAS.BUILDING)) {
      url += `&buildingId=${talk.buildingId}`;
    }

    try {
      const result = await getTalkPostList(url);
      if (result.status === HttpStatusCode.Ok) {
        if (result.data.items.length > 0) {
          setPostList(result.data.items);
        } else {
          const result = await getTalkPostList(
            url.replace("dateRange=7", "dateRange=30")
          );
          if (result.status === HttpStatusCode.Ok) {
            setPostList(result.data.items);
          } else {
            setPostList([]);
          }
        }
      } else {
        setPostList([]);
      }
    } catch (e: any) {
      setPostList([]);
    } finally {
      setIsPostLoading(false);
    }
  };

  const handleSearchSubmit = (searchQuery: string) => {
    navigate("/view/search", { state: { searchQuery } });
  };

  const getUniqueBuildingList = (memberSpaceList: SpaceItem[]) => {
    const uniqueBuildingList: SpaceItem[] = [];
    memberSpaceList.forEach((item) => {
      if (
        !uniqueBuildingList
          .map((item) => getBuildingKey(item))
          .includes(getBuildingKey(item))
      ) {
        uniqueBuildingList.push(item);
      } else {
        // nothing to do
      }
    });
    return uniqueBuildingList.slice(0, 5);
  };

  useEffect(() => {
    if (selectedBuilding.buildingId) {
      getToiletMonitoringInfo({ buildingId: selectedBuilding.buildingId }).then(
        (res) => {
          if (res.status === HttpStatusCode.Ok) {
            let totalCount = 0;
            let openCount = 0;

            res.data[0]?.floors
              ?.filter(
                (toilet) =>
                  toilet.buildingFloorId === selectedBuilding.buildingFloorId
              )
              ?.forEach((floor) =>
                floor.toilets.map((toilet) => {
                  if (toilet.gender === user.gender) {
                    if (isCleaning(toilet)) {
                      setToiletIsCleaning(true);
                    }
                    openCount += getOpenCount(toilet.compartments);
                    totalCount += toilet.compartments.length;
                  }
                  return toilet;
                })
              );
            setTotalToiletCount(totalCount);
            setToiletRate(totalCount === 0 ? 0 : openCount / totalCount);
          }
        }
      );
    }
  }, [selectedBuilding.buildingId]);

  useEffect(() => {
    if (!selectedBuilding.buildingId) return;

    loadPostList();
  }, [selectedBuilding.buildingId, selectedSandiTalkCategory]);

  useEffect(() => {
    const loadBuildingCategory = async () => {
      if (activeServiceTab !== "manager") {
        try {
          const result = await getTalkCategories({
            buildingId: selectedBuilding.buildingId,
          });
          if (result.status === HttpStatusCode.Ok) {
            const buildingCategory = result.data.find((category) =>
              category?.alias?.includes(CATEGORY_ALIAS.BUILDING)
            );
            if (buildingCategory) {
              setBuildingCategoryList(buildingCategory?.lifeCategoryList ?? []);
            }
          } else {
            throw new Error("카테고리 조회 실패");
          }
        } catch (e: any) {
          openError(e, "카테고리 조회 실패");
        }
      }
    };

    loadBuildingCategory();
  }, [activeServiceTab, selectedBuilding.buildingId]);

  useEffect(() => {
    setSupportToilet(
      services.service?.find(
        (service) =>
          service.serviceTemplateId === SERVICE_TEMPLATE_ID.TOILET_EMPTY
      )?.serviceId != null
        ? true
        : false
    );
  }, [services.service]);

  useEffect(() => {
    if (user.isLoading && !selectedBuilding?.buildingId) return;
    setIsLoading(true);
    setIsLoadingService(true);
    Promise.allSettled([
      searchService({
        buildingId: selectedBuilding?.buildingId,
        pageSize: 50,
      }),
      getTotalService({
        isManager: true,
        buildingId: selectedBuilding?.buildingId,
      }),
      getBanner({ location: "MAINROLL" }),
      getManagerNotice(),
      getMemberSpaceList(),
      getTalkPostList(
        `pinelife/post/list?category=${CATEGORY_ALIAS.BUILDING_NOTICE}&buildingId=${selectedBuilding.buildingId}&pageSize=1`
      ),
      getBanner({ location: "MAINFIX" }),
      getMemberShipInfo(),
    ])
      .then((ress) => {
        if (
          ress[0].status === "fulfilled" &&
          ress[0].value.status === HttpStatusCode.Ok
        ) {
          const service = ress[0].value.data.items as
            | UserServiceResponse[]
            | undefined;
          setServices((prev) => ({ ...prev, service }));
          setMemberShipService(
            service?.find((item) =>
              [
                SERVICE_DETAIL_ITEM_TYPE.OUR_HOME,
                SERVICE_DETAIL_ITEM_TYPE.SMART_OLIVE,
              ].includes(item.serviceDetailType)
            )
          );
        } else {
          setServices((prev) => ({ ...prev, service: [] }));
          setMemberShipService(undefined);
        }
        if (
          ress[1].status === "fulfilled" &&
          ress[1].value.status === HttpStatusCode.Ok
        ) {
          const manager = ress[1].value.data;
          setServices((prev) => ({ ...prev, manager }));
          if (manager.length > 0) {
            setActiveServiceTab("manager");
          }
          if (activeServiceTab === "manager" && manager.length <= 0) {
            setActiveServiceTab("service");
          }
        } else {
          setServices((prev) => ({ ...prev, manager: [] }));
        }
        if (
          ress[2].status === "fulfilled" &&
          ress[2].value.status === HttpStatusCode.Ok
        ) {
          setMainRollBanner(ress[2].value.data.items);
        } else {
          setMainRollBanner([]);
        }
        if (
          ress[3].status === "fulfilled" &&
          ress[3].value.status === HttpStatusCode.Ok
        ) {
          setNoticePost(ress[3].value.data);
        }
        if (
          ress[4].status === "fulfilled" &&
          ress[4].value.status === HttpStatusCode.Ok
        ) {
          setMemberSpaceList(ress[4].value.data);
        }
        if (
          ress[5].status === "fulfilled" &&
          ress[5].value.status === HttpStatusCode.Ok
        ) {
          setBuildingNoticePost(ress[5].value.data.items?.[0]);
        }
        if (
          ress[6].status === "fulfilled" &&
          ress[6].value.status === HttpStatusCode.Ok
        ) {
          setMainFixBanner(ress[6].value.data.items);
        } else {
          setMainFixBanner([]);
        }
        if (
          ress[7].status === "fulfilled" &&
          ress[7].value.status === HttpStatusCode.Ok
        ) {
          setMemberShip(ress[7].value.data);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
        setIsBannerLoading(false);
        setIsLoadingService(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBuilding.buildingId, user.isLoading]);

  useEffect(() => {
    if (user.isLoading && !user.buildingId) return;
    setSelectedBuilding({
      buildingId: user.buildingId,
      buildingName: user.buildingName,
      buildingFloorId: user.buildingFloorId,
      buildingFloorName: user.buildingFloorName,
      buildingSpaceId: user.buildingSpaceId,
      buildingSpaceName: user.buildingSpaceName,
    });
  }, [user.buildingId, user.isLoading]);

  return (
    <div>
      {loadingComponent}
      {!boarded && <OnBoard />}
      <div className="fixed flex justify-between items-center py-4 px-5 top-0 bg-white z-30 w-full">
        {!user?.logoUrl ? (
          <Skeleton className="w-[93px] h-[22px] rounded-full" />
        ) : (
          <img
            className="w-auto h-[22px]"
            data-testid={"top-logo-img"}
            src={user?.logoUrl}
          />
        )}
        <div className="flex gap-4">
          <div className="relative">
            <div
              onClick={() => {
                handleSearchSubmit("");
              }}
            >
              <ZoomSearchIcon />
            </div>
          </div>
          <div className="cursor-pointer" onClick={() => navigate("/alarm")}>
            <RingNotificationIcon />
          </div>
        </div>
      </div>

      <div className="sticky flex justify-between items-center py-4 px-5 top-0 bg-white z-20 h-[56px]"></div>

      <div className="px-5">
        <div
          className={clsx([
            "p-5 pr-2.5 pb-[15px] flex justify-between items-center rounded-t-[10px] relative z-10",
            { "rounded-b-[10px]": !buildingNoticePost },
          ])}
          style={{ boxShadow: "0px 1px 5px 0px rgba(0, 0, 0, 0.10)" }}
        >
          <div className="flex flex-col gap-1.5">
            {isLoading === true ? (
              <Skeleton className="w-[100px] h-[20px] rounded-full" />
            ) : (
              <div className=" bg-brand-floating-primary-button text-transparent bg-clip-text text-xs flex gap-1 items-center">
                <CommonSelect
                  defaultValue={getBuildingKey(selectedBuilding)}
                  value={getBuildingKey(selectedBuilding)}
                  renderLabel={selectedBuilding.buildingName}
                  optionList={getUniqueBuildingList(memberSpaceList).map(
                    (item) =>
                      ({
                        label: getBuildingLabel(item),
                        value: getBuildingKey(item),
                      } as SelectOption)
                  )}
                  onChange={async (value) => {
                    const selectedBuilding = memberSpaceList.find(
                      (item) => getBuildingKey(item) === value.value
                    );

                    setIsLoading(true);
                    try {
                      const result = await updateMemberSpace({
                        buildingId: selectedBuilding?.buildingId as string,
                        buildingFloorId:
                          selectedBuilding?.buildingFloorId as string,
                        buildingSpaceId:
                          selectedBuilding?.buildingSpaceId as string,
                      });
                      if (result.status === HttpStatusCode.Ok) {
                        // nothing to do
                        updateField({
                          buildingId: selectedBuilding?.buildingId ?? "",
                          buildingName: selectedBuilding?.buildingName ?? "",
                          buildingFloorId:
                            selectedBuilding?.buildingFloorId ?? "",
                          buildingFloorName:
                            selectedBuilding?.buildingFloorName ?? "",
                          buildingSpaceId:
                            selectedBuilding?.buildingSpaceId ?? "",
                          buildingSpaceName:
                            selectedBuilding?.buildingSpaceName ?? "",
                        });
                        updateTalkField({
                          buildingId: selectedBuilding?.buildingId,
                        });

                        setSelectedBuilding({
                          buildingId: selectedBuilding?.buildingId ?? "",
                          buildingName: selectedBuilding?.buildingName ?? "",
                          buildingFloorId:
                            selectedBuilding?.buildingFloorId ?? "",
                          buildingFloorName:
                            selectedBuilding?.buildingFloorName ?? "",
                          buildingSpaceId:
                            selectedBuilding?.buildingSpaceId ?? "",
                          buildingSpaceName:
                            selectedBuilding?.buildingSpaceName ?? "",
                        });
                      } else {
                        throw new Error("근무 위치 변경에 실패하였습니다.");
                      }
                    } catch (e: any) {
                      openError(e, "근무 위치 변경에 실패하였습니다.");
                    } finally {
                      setIsLoading(false);
                    }
                  }}
                  labelClassName={clsx([
                    "design_min:truncate",
                    {
                      "design_min:max-w-[calc(100vw-255px)]": supportToilet,
                      "design_min:max-w-[calc(100vw-200px)]": !supportToilet,
                    },
                  ])}
                  className="border-none text-black bg-clip-text text-base font-semibold pl-0 py-0 flex gap-2"
                  optionClassName="text-black text-sm"
                  optionWidth="180px"
                  arrowIcon={<HomeSelectIcon />}
                  prefixIcon={<HomeLocationArrow />}
                  optionOrder="left"
                  additionalDiv={
                    <div className="flex flex-col px-4 text-brand-neutral-50 pb-2">
                      {memberSpaceList.length &&
                        memberSpaceList.filter(
                          (item) => item.buildingId !== user.buildingId
                        ).length > 0 && <HorizontalRule margin="0" />}
                      <div
                        className="py-2.5 text-sm"
                        onClick={() => navigate("/myinfo/change/building")}
                      >
                        근무위치 변경
                      </div>
                    </div>
                  }
                  unUseUniqueCheck
                />
              </div>
            )}

            <div className=" text-sm">
              {isLoading === true ? (
                <Skeleton className=" rounded-full w-[100px] h-[20px]" />
              ) : (
                selectedBuilding.buildingFloorName
              )}
            </div>
          </div>

          <div className="flex gap-[5px] items-center h-[45px]">
            <div
              className="w-[60px] flex flex-col gap-[5px] items-center"
              onClick={() =>
                navigate(`/view/buildingInfo/${selectedBuilding.buildingId}`)
              }
            >
              <div>
                <HomeBuildingInfoIcon />
              </div>
              <div className="text-xs font-semibold leading-4 text-brand-primary-gray-100">
                건물 정보
              </div>
            </div>
            {selectedBuilding.buildingId &&
              supportToilet &&
              totalToiletCount > 0 && (
                <>
                  <VerticalRule className="!h-full !bg-[#f2f2f2]" />
                  <div
                    className="w-[60px] flex flex-col gap-[5px] items-center"
                    onClick={() =>
                      navigate("/service/toilet-empty", {
                        state: selectedBuilding,
                      })
                    }
                  >
                    {toiletIsCleaning ? (
                      <div>
                        <HomeCleaningIcon />
                      </div>
                    ) : (
                      <div>
                        {toiletRate > 0.5 ? (
                          <HomeToiletGood />
                        ) : (
                          <HomeToiletBad />
                        )}
                      </div>
                    )}

                    <div
                      className={clsx([
                        "text-xs font-semibold leading-4 text-brand-primary-gray-100",
                      ])}
                    >
                      화장실
                    </div>
                  </div>
                </>
              )}
          </div>
        </div>
        {buildingNoticePost && (
          <div
            className="rounded-b-[10px] py-2.5 px-[15px] bg-brand-gray-140 text-white text-xs flex items-center gap-2.5 justify-between"
            onClick={() => navigate(`/talk/${buildingNoticePost.lifePostId}`)}
          >
            <div className="flex items-center gap-1">
              <HomeBuildingNoticeIcon />
              <div className="truncate w-[calc(100vw-100px)]">
                {buildingNoticePost.title}
              </div>
              <ViewNoticeLinkIcon />
            </div>
          </div>
        )}

        <div className="py-5 flex items-center">
          {memberShipService &&
            memberShipService.serviceDetailType ===
              memberShip.serviceDetailType && (
              <MemberShip
                memberShip={memberShip}
                image={memberShipService?.iconUrl ?? ""}
                imgClassName={clsx({
                  "rounded-[10px]": isSmartOlive(memberShip.serviceDetailType),
                })}
                needAuthorized={memberShipService.needAuthorized}
                onClick={() => {
                  if (isSmartOlive(memberShip.serviceDetailType)) {
                    handleNavigateService(
                      memberShipService,
                      undefined,
                      undefined,
                      handleNavigateSmartOlive
                    );
                  } else if (
                    memberShip.serviceDetailType ===
                    SERVICE_DETAIL_ITEM_TYPE.OUR_HOME
                  ) {
                    handleNavigateService(memberShipService);
                  } else {
                    open(
                      "사원카드 정보를 불러오는데 실패했습니다.\n관리자에게 문의해주세요."
                    );
                  }
                }}
              />
            )}
          {services.service?.find(
            (item) =>
              item.serviceDetailType === SERVICE_DETAIL_ITEM_TYPE.CAFETERIA
          ) && (
            <div
              className="flex justify-between items-center pb-2 flex-1"
              onClick={() => {
                updateCategoryFromLocation(CATEGORY.BUILDING_MENU);
                navigate("/talk", {
                  state: {
                    ...selectedBuilding,
                    lifeCategoryId: CATEGORY.BUILDING_MENU,
                  },
                });
              }}
            >
              <div className="flex items-center gap-2.5">
                <img
                  src={CafeteriaCI}
                  alt="cafeteria_ci"
                  className="w-[50px] h-[50px]"
                />
                <div className="flex flex-col">
                  <div className="text-xs text-brand-neutral-70">사원식당</div>
                  <div className="text-base font-medium">
                    <strong className="text-lg font-bold">메뉴조회</strong>
                  </div>
                </div>
              </div>
              <div>
                <RemainBalanceRightArrow />
              </div>
            </div>
          )}
        </div>
      </div>
      <HorizontalRule margin="0" className=" bg-black bg-opacity-5" />
      <div className="flex flex-col gap-2 bg-brand-main-page-background">
        {/* 메인 전체 */}
        <div className="bg-white py-7 px-5 flex flex-col">
          {/* 추천 서비스 */}
          <div className="flex flex-col gap-4">
            <div className="flex justify-between items-center">
              <div className=" text-xl font-medium">샌디가 추천드려요</div>
              <div className=" bg-brand-primary-gray-100 bg-opacity-30 text-white text-opacity-60 rounded-full h-5 flex gap-1 text-xs items-center px-1.5">
                <span className="font-bold text-white">
                  {mainRollBanner.length > 0 ? activeMainBannerIndex + 1 : 0}
                </span>{" "}
                <VerticalRule className="!bg-white !bg-opacity-20" />{" "}
                {mainRollBanner.length}
              </div>
            </div>
            <MainBanner
              bannerList={mainRollBanner}
              onSlideChange={(index) => {
                setActiveMainBannerIndex(index);
              }}
              isLoading={isBannerLoading}
            />
          </div>
          <div className="pt-[30px] pb-5">
            <div className="flex justify-between items-center">
              <div className="flex items-center">
                {!isArrayEmpty(services.manager) && (
                  <ServiceTab
                    active={activeServiceTab === "manager"}
                    onClick={() => setActiveServiceTab("manager")}
                  >
                    <span className={clsx([{ "magenta-dot": noticePost }])}>
                      샌디매니저
                    </span>
                  </ServiceTab>
                )}
                <ServiceTab
                  active={activeServiceTab === "service"}
                  onClick={() => setActiveServiceTab("service")}
                >
                  {isLoading === true ? (
                    <Skeleton className="rounded-full w-[100px] h-[15px]" />
                  ) : (
                    <strong>{user.nickname}</strong>
                  )}
                  님의 서비스
                </ServiceTab>
              </div>
              <div className=" self-start" onClick={() => navigate("/service")}>
                <div className="flex h-6 items-center">
                  <PlusIcon />
                </div>
              </div>
            </div>
            <HorizontalRule margin="0" />

            {selectedBuilding.buildingId && selectedBuilding.buildingFloorId ? (
              <>
                {!user.role?.includes(MANAGER_ROLE.USER) && noticePost && (
                  <div
                    className="flex justify-between items-center py-2.5"
                    onClick={() => navigate(`/talk/${noticePost.lifePostId}`)}
                  >
                    <div className=" text-brand-primary-gray-100 text-xs flex items-center gap-1">
                      <HomeNoticeIcon />
                      {noticePost.title}
                    </div>

                    <div>
                      <RemainBalanceRightArrow />
                    </div>
                  </div>
                )}

                <div className="grid grid-cols-4 gap-x-[5px]">
                  {(services[activeServiceTab as keyof ServiceObject]?.length ??
                    0) > 0 ? (
                    services[activeServiceTab as keyof ServiceObject]?.map(
                      (service, index) => (
                        <div
                          key={index}
                          className={clsx(
                            "py-[14px] whitespace-pre-line text-sm text-center flex flex-col gap-2 items-center relative",
                            {
                              "cursor-not-allowed":
                                !service.serviceId ||
                                service.needAuthorized === true ||
                                service.serviceStatus === "only-occupant",
                            }
                          )}
                          onClick={() => {
                            if (isSmartOlive(service.serviceDetailType)) {
                              handleNavigateService(
                                service,
                                buildingCategoryList,
                                activeServiceTab,
                                handleNavigateSmartOlive
                              );
                            } else {
                              handleNavigateService(
                                service,
                                buildingCategoryList,
                                activeServiceTab
                              );
                            }
                          }}
                        >
                          <div
                            className={clsx({
                              "opacity-60":
                                !service.serviceId ||
                                service.needAuthorized === true ||
                                service.serviceStatus === "only-occupant",
                            })}
                          >
                            {isLoadingService ? (
                              <Skeleton className="h-[56px] w-[56px] rounded-full" />
                            ) : (
                              <div className="h-[56px] w-[56px] flex items-center justify-center rounded-full bg-brand-weather-badge-background">
                                {service.fileInfo?.items.length > 0 && (
                                  <img
                                    src={
                                      [
                                        SERVICE_DETAIL_ITEM_TYPE.OUR_HOME,
                                        SERVICE_DETAIL_ITEM_TYPE.SMART_OLIVE,
                                      ].includes(service.serviceDetailType)
                                        ? MemberShipCardCI
                                        : service.fileInfo.items?.[0]?.url
                                    }
                                    alt={service.serviceName}
                                    className={clsx([
                                      "w-[36px] h-[36px] object-contain",
                                      {
                                        "opacity-60": !service.serviceId,
                                      },
                                    ])}
                                  />
                                )}
                              </div>
                            )}
                          </div>

                          {isLoadingService ? (
                            <div className="flex flex-col gap-0.5">
                              <Skeleton className="h-[15px] w-[56px] rounded-full" />
                              <Skeleton className="h-[15px] w-[56px] rounded-full" />
                            </div>
                          ) : (
                            <p className="break-words text-[13px] tracking-[-0.26px] mt-0">
                              {getServiceNameWithNewLine(service.serviceName)}
                            </p>
                          )}

                          {!isLoadingService && (
                            <ServiceBadge
                              service={service}
                              categoryList={buildingCategoryList}
                              className="absolute top-[45px] left-1/2 -translate-x-1/2 whitespace-nowrap"
                            />
                          )}
                        </div>
                      )
                    )
                  ) : (
                    <div className=" col-span-4 h-40 flex flex-col items-center justify-center gap-2">
                      <NoDataIcon />
                      관리할 수 있는 서비스가 없어요.
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div className="pt-2.5">
                <div className=" bg-brand-weather-badge-background py-[30px] px-2.5 flex flex-col justify-end items-center gap-2.5 rounded-[3px]">
                  <div className="flex items-center justify-center gap-1.5 text-sm text-brand-neutral-60 leading-[18px]">
                    <HomeWorkLocationIcon />
                    근무 위치를 설정해 주세요
                  </div>
                  <CommonButton
                    variant="secondary"
                    className="py-[11px] px-4 w-[200px] h-bottom-button !text-sm font-medium !leading-[17px]"
                    onClick={() => navigate("/myinfo/change/building")}
                  >
                    근무 위치 변경
                  </CommonButton>
                </div>
              </div>
            )}
          </div>

          <HorizontalRule margin="0" className=" bg-black bg-opacity-5" />

          {/* 샌디톡 */}
          <div className="flex flex-col gap-5 pt-[30px] pb-5">
            <div className="flex justify-between items-center">
              <div className=" text-xl font-semibold whitespace-pre-line">
                {"지금 인기있는 샌디톡"}
              </div>
              <div
                onClick={() => navigate("/talk")}
                className="self-end h-[26px] flex items-center"
              >
                <PlusIcon />
              </div>
            </div>

            <div className="flex flex-col gap-3">
              <div className="flex gap-2">
                {sandiTalkCategoryList.map((category, index) => (
                  <Badge
                    key={index}
                    active={category.name === selectedSandiTalkCategory}
                    onClick={() => setSelectedSandiTalkCategory(category.name)}
                  >
                    {category.name}
                  </Badge>
                ))}
              </div>
              <PostSwiper
                postList={postList}
                onReload={loadPostList}
                type="view"
                isLoading={isLoading && isPostLoading}
                useCategory={selectedSandiTalkCategory === "인기글"}
              />
            </div>
          </div>
        </div>
      </div>

      {mainFixBanner.length && mainFixBanner.length > 0 ? (
        <DefaultBanner
          position="MAINFIX"
          item={mainFixBanner[0]}
          className="w-full items-center justify-center pt-5"
          imageClassName="w-full object-cover"
        />
      ) : (
        <div className="flex flex-col w-full justify-between items-center pb-4 pt-8 bg-sandi-business gap-6">
          <div className="flex justify-between px-5 w-full">
            <div className="flex flex-col">
              <div className=" text-xl font-semibold">샌디 비즈니스</div>
              <div className=" text-sm font-medium">
                공간 관리에 진심이니까요
              </div>
            </div>
            <div>
              <SandiCI />
            </div>
          </div>
          <CommonButton //자세히 보기
            variant="default"
            disabled
            className="w-fit pl-6 pr-2.5 !bg-brand-primary-gray-100 !text-white text-xs font-medium"
          >
            준비중
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.3335 6.66663L11.0776 9.4107C11.403 9.73614 11.403 10.2638 11.0776 10.5892L8.3335 13.3333"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="square"
              />
            </svg>
          </CommonButton>
        </div>
      )}
      <Isms ISMSImgSizePixel={48} className="pt-6" />
      {simplePopupComponent}
      {navigateServiceComponent}
    </div>
  );
}

export type MemberShipProps = {
  memberShip: Partial<MemberShipCardInfo>;
  image: string;
  imgClassName?: string;
  needAuthorized?: boolean | null;
  onClick?: () => void;
};

export const MemberShip = ({
  memberShip,
  image,
  imgClassName,
  needAuthorized = false,
  onClick,
}: MemberShipProps) => {
  const ERROR_NOT_LOGIN = "ERROR_NOT_LOGIN"; // 로그인 후 사용 가능합니다

  return (
    <div
      className="flex justify-between items-center pb-2 flex-1"
      onClick={onClick}
    >
      <div className="flex items-center gap-2.5">
        {image && (
          <img
            src={image}
            alt="memberShip_ci"
            className={clsx("w-[50px] h-[50px]", imgClassName)}
          />
        )}
        <div className="flex flex-col">
          <div className="text-xs text-brand-neutral-70">
            {replaceMemberShipName(memberShip.serviceDetailType)}
          </div>
          {needAuthorized || memberShip.resultCode === ERROR_NOT_LOGIN ? (
            <strong className="text-[18px]">인증필요</strong>
          ) : (
            <div className="text-base font-medium">
              <strong className="text-lg font-extrabold">
                {(memberShip?.amount ?? 0).toLocaleString()}
              </strong>
              원
            </div>
          )}
        </div>
      </div>
      <div>
        <RemainBalanceRightArrow />
      </div>
    </div>
  );
};

export type ServiceTabProps = {
  children?: React.ReactNode;
  active?: boolean;
  onClick?: () => void;
};

export const ServiceTab = ({ children, active, onClick }: ServiceTabProps) => {
  return (
    <div className="flex flex-col gap-3" onClick={onClick}>
      <div className="flex justify-center items-center px-2">{children}</div>
      <div
        className={clsx([
          "w-full bg-brand-floating-primary-button h-[3px] transition-all",
          {
            "opacity-100": active,
            "opacity-0": !active,
          },
        ])}
      ></div>
    </div>
  );
};

export const ViewNoticeLinkIcon = ({
  stroke = "white",
}: {
  stroke?: string;
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.3">
      <path
        d="M5.46094 13.8993L10.5388 8.82147L5.46094 3.74365"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const HomeCleaningIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="BigCleaningIcon"
  >
    <circle cx="12" cy="12.9954" r="12" fill="#FFB932" />
    <circle cx="12" cy="12.9954" r="12" fill="#FFB932" />
    <path
      d="M20.172 18.238L19.8513 18.6595H4.1186L3.82812 18.238L11.9377 4.01147H12.0668L20.172 18.238Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12.0011 12.7709V9.8999"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
    <path
      d="M11.9946 15.6279H12.0038"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
    <path
      d="M12.0011 12.7709V9.8999"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
    <path
      d="M11.9946 15.6279H12.0038"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
  </svg>
);

export const HomeToiletBad = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12.7031" cy="12.5405" r="12" fill="#E7004B" />
    <path
      d="M7.70312 17.5405C8.95804 16.3088 10.7341 15.5405 12.7031 15.5405C14.6722 15.5405 16.4482 16.3088 17.7031 17.5405"
      stroke="white"
    />
    <path d="M6.70312 7.54053L10.7031 11.5405" stroke="white" />
    <path d="M10.7031 7.54053L6.70312 11.5405" stroke="white" />
    <path d="M14.7031 7.54053L18.7031 11.5405" stroke="white" />
    <path d="M18.7031 7.54053L14.7031 11.5405" stroke="white" />
  </svg>
);

export const HomeToiletGood = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#00CDC1" />
    <path
      d="M6 15C7.5059 16.8475 9.63712 18 12 18C14.3629 18 16.4941 16.8475 18 15"
      stroke="white"
    />
    <circle cx="8" cy="10" r="2" fill="white" />
    <circle cx="16" cy="10" r="2" fill="white" />
  </svg>
);

export const HomeBuildingNoticeIcon = ({
  fill = "white",
}: {
  fill?: string;
}) => (
  <svg
    width="13"
    height="11"
    viewBox="0 0 13 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.34276 7.95887L3.59988 7.53005L3.48117 7.45887H3.34276V7.95887ZM3.34276 3.27641V3.77641H3.48117L3.59988 3.70523L3.34276 3.27641ZM7.24735 0.935181H7.74735C7.74735 0.75507 7.65048 0.588879 7.49376 0.500116C7.33704 0.411353 7.1447 0.413739 6.99023 0.50636L7.24735 0.935181ZM7.24735 10.3001L6.99023 10.7289C7.1447 10.8215 7.33704 10.8239 7.49376 10.7352C7.65048 10.6464 7.74735 10.4802 7.74735 10.3001H7.24735ZM11.5054 2.92274L11.1517 2.5693L10.4448 3.27664L10.7985 3.63008L11.5054 2.92274ZM10.7985 7.6052L10.4448 7.95864L11.1517 8.66598L11.5054 8.31254L10.7985 7.6052ZM3.34276 7.45887H1.78092V8.45887H3.34276V7.45887ZM1.78092 7.45887C1.62536 7.45887 1.5 7.33325 1.5 7.17846H0.5C0.5 7.8868 1.07434 8.45887 1.78092 8.45887V7.45887ZM1.5 7.17846V4.05682H0.5V7.17846H1.5ZM1.5 4.05682C1.5 3.90203 1.62536 3.77641 1.78092 3.77641V2.77641C1.07434 2.77641 0.5 3.34848 0.5 4.05682H1.5ZM1.78092 3.77641H3.34276V2.77641H1.78092V3.77641ZM3.59988 3.70523L7.50448 1.364L6.99023 0.50636L3.08563 2.84759L3.59988 3.70523ZM6.74735 0.935181V10.3001H7.74735V0.935181H6.74735ZM7.50448 9.87128L3.59988 7.53005L3.08563 8.38769L6.99023 10.7289L7.50448 9.87128ZM11.1519 3.27641C10.7985 3.63008 10.7983 3.62991 10.7982 3.62974C10.7981 3.62969 10.798 3.62953 10.7979 3.62942C10.7976 3.62921 10.7975 3.62902 10.7973 3.62883C10.7969 3.62846 10.7966 3.62814 10.7963 3.62786C10.7957 3.6273 10.7954 3.62691 10.7952 3.62671C10.7948 3.62631 10.7951 3.62662 10.7961 3.62765C10.798 3.6297 10.8025 3.63461 10.8093 3.64237C10.8229 3.65789 10.8454 3.68474 10.8741 3.72286C10.9313 3.79918 11.0125 3.9201 11.0953 4.08544C11.2599 4.41449 11.4329 4.92367 11.4329 5.61764H12.4329C12.4329 4.75079 12.2154 4.08936 11.9896 3.63799C11.8771 3.41313 11.763 3.24139 11.6739 3.12261C11.6293 3.06319 11.5908 3.01687 11.5617 2.98362C11.5471 2.96699 11.5349 2.9536 11.5254 2.94347C11.5206 2.9384 11.5165 2.93414 11.5132 2.93068C11.5115 2.92896 11.51 2.92743 11.5087 2.92611C11.5081 2.92545 11.5075 2.92483 11.5069 2.92427C11.5066 2.92399 11.5064 2.92372 11.5061 2.92347C11.506 2.92334 11.5058 2.92316 11.5057 2.9231C11.5056 2.92292 11.5054 2.92274 11.1519 3.27641ZM11.4329 5.61764C11.4329 6.31161 11.2599 6.82079 11.0953 7.14984C11.0125 7.31518 10.9313 7.4361 10.8741 7.51242C10.8454 7.55054 10.8229 7.57739 10.8093 7.59291C10.8025 7.60067 10.798 7.60558 10.7961 7.60764C10.7951 7.60866 10.7948 7.60897 10.7952 7.60857C10.7954 7.60837 10.7957 7.60799 10.7963 7.60742C10.7966 7.60714 10.7969 7.60682 10.7973 7.60645C10.7975 7.60626 10.7976 7.60607 10.7979 7.60586C10.798 7.60575 10.7981 7.60559 10.7982 7.60554C10.7983 7.60537 10.7985 7.6052 11.1519 7.95887C11.5054 8.31254 11.5056 8.31236 11.5057 8.31218C11.5058 8.31212 11.506 8.31194 11.5061 8.31181C11.5064 8.31156 11.5066 8.31129 11.5069 8.31101C11.5075 8.31045 11.5081 8.30983 11.5087 8.30917C11.51 8.30785 11.5115 8.30632 11.5132 8.3046C11.5165 8.30115 11.5206 8.29688 11.5254 8.29181C11.5349 8.28168 11.5471 8.26829 11.5617 8.25166C11.5908 8.21841 11.6293 8.17209 11.6739 8.11267C11.763 7.99389 11.8771 7.82215 11.9896 7.59729C12.2154 7.14592 12.4329 6.48449 12.4329 5.61764H11.4329Z"
      fill={fill}
    />
  </svg>
);

export const HomeWorkLocationIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.97819 14.0275L4.13484 10.3128C3.39332 9.58128 2.89175 8.6545 2.69301 7.64861C2.49426 6.64273 2.6072 5.60252 3.01765 4.65843C3.4281 3.71433 4.1178 2.90837 5.00026 2.3416C5.88272 1.77484 6.91867 1.4725 7.97819 1.4725C9.03772 1.4725 10.0737 1.77484 10.9561 2.3416C11.8386 2.90837 12.5283 3.71433 12.9387 4.65843C13.3492 5.60252 13.4621 6.64273 13.2634 7.64862C13.0646 8.6545 12.5631 9.58128 11.8215 10.3128L7.97819 14.0275Z"
      fill="#B7B7B8"
      stroke="#B7B7B8"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1743 6.93431C10.1743 8.14714 9.19108 9.13033 7.97825 9.13033C6.76542 9.13033 5.78223 8.14714 5.78223 6.93431C5.78223 5.72148 6.76542 4.73828 7.97825 4.73828C9.19108 4.73828 10.1743 5.72148 10.1743 6.93431Z"
      fill="white"
      stroke="white"
      strokeWidth="1.75"
    />
  </svg>
);

export const HomeSelectIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.1" cx="10.4998" cy="10" r="9.59985" fill="#333F48" />
    <path
      d="M6.93713 8.90625L10.4998 12.4689L14.0625 8.90625"
      stroke="#333F48"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

export const HomeLocationArrow = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 0.75L4.64286 9.25L5.85714 5.60714L9.5 4.39286L1 0.75Z"
      fill="url(#paint0_linear_1401_38372)"
      stroke="url(#paint1_linear_1401_38372)"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1401_38372"
        x1="9.5"
        y1="0.75"
        x2="0.450375"
        y2="3.07914"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E0004D" />
        <stop offset="1" stopColor="#EA27C2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1401_38372"
        x1="9.5"
        y1="0.75"
        x2="0.450375"
        y2="3.07914"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E0004D" />
        <stop offset="1" stopColor="#EA27C2" />
      </linearGradient>
    </defs>
  </svg>
);

export const HomeNoticeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="10" fill="#FFE9F1" />
    <path
      d="M6.87645 12.3412L7.13357 11.9124L7.01486 11.8412H6.87645V12.3412ZM6.87645 7.65873V8.15873H7.01486L7.13357 8.08756L6.87645 7.65873ZM10.781 5.3175H11.281C11.281 5.13739 11.1842 4.9712 11.0275 4.88244C10.8707 4.79368 10.6784 4.79606 10.5239 4.88868L10.781 5.3175ZM10.781 14.6824L10.5239 15.1112C10.6784 15.2039 10.8707 15.2063 11.0275 15.1175C11.1842 15.0287 11.281 14.8625 11.281 14.6824H10.781ZM15.0391 7.30507L14.6854 6.95163L13.9785 7.65897L14.3322 8.0124L15.0391 7.30507ZM14.3322 11.9875L13.9785 12.341L14.6854 13.0483L15.0391 12.6949L14.3322 11.9875ZM6.87645 11.8412H5.31461V12.8412H6.87645V11.8412ZM5.31461 11.8412C5.15905 11.8412 5.03369 11.7156 5.03369 11.5608H4.03369C4.03369 12.2691 4.60803 12.8412 5.31461 12.8412V11.8412ZM5.03369 11.5608V8.43914H4.03369V11.5608H5.03369ZM5.03369 8.43914C5.03369 8.28435 5.15905 8.15873 5.31461 8.15873V7.15873C4.60803 7.15873 4.03369 7.7308 4.03369 8.43914H5.03369ZM5.31461 8.15873H6.87645V7.15873H5.31461V8.15873ZM7.13357 8.08756L11.0382 5.74633L10.5239 4.88868L6.61932 7.22991L7.13357 8.08756ZM10.281 5.3175V14.6824H11.281V5.3175H10.281ZM11.0382 14.2536L7.13357 11.9124L6.61932 12.77L10.5239 15.1112L11.0382 14.2536ZM14.6856 7.65873C14.3322 8.0124 14.332 8.01223 14.3319 8.01207C14.3318 8.01201 14.3316 8.01185 14.3315 8.01175C14.3313 8.01154 14.3311 8.01134 14.331 8.01116C14.3306 8.01079 14.3303 8.01046 14.33 8.01018C14.3294 8.00962 14.3291 8.00924 14.3289 8.00904C14.3285 8.00863 14.3288 8.00894 14.3298 8.00997C14.3317 8.01202 14.3362 8.01693 14.343 8.02469C14.3566 8.04022 14.3791 8.06706 14.4078 8.10519C14.465 8.18151 14.5462 8.30242 14.6289 8.46777C14.7936 8.79681 14.9666 9.306 14.9666 9.99996H15.9666C15.9666 9.13311 15.7491 8.47168 15.5233 8.02032C15.4107 7.79545 15.2967 7.62372 15.2076 7.50494C15.163 7.44551 15.1245 7.39919 15.0954 7.36594C15.0808 7.34931 15.0686 7.33593 15.0591 7.32579C15.0543 7.32072 15.0502 7.31646 15.0469 7.31301C15.0452 7.31128 15.0437 7.30975 15.0424 7.30843C15.0418 7.30777 15.0412 7.30716 15.0406 7.3066C15.0403 7.30632 15.0401 7.30605 15.0398 7.30579C15.0397 7.30567 15.0395 7.30548 15.0394 7.30542C15.0393 7.30524 15.0391 7.30507 14.6856 7.65873ZM14.9666 9.99996C14.9666 10.6939 14.7936 11.2031 14.6289 11.5322C14.5462 11.6975 14.465 11.8184 14.4078 11.8947C14.3791 11.9329 14.3566 11.9597 14.343 11.9752C14.3362 11.983 14.3317 11.9879 14.3298 11.99C14.3288 11.991 14.3285 11.9913 14.3289 11.9909C14.3291 11.9907 14.3294 11.9903 14.33 11.9897C14.3303 11.9895 14.3306 11.9891 14.331 11.9888C14.3311 11.9886 14.3313 11.9884 14.3315 11.9882C14.3316 11.9881 14.3318 11.9879 14.3319 11.9879C14.332 11.9877 14.3322 11.9875 14.6856 12.3412C15.0391 12.6949 15.0393 12.6947 15.0394 12.6945C15.0395 12.6944 15.0397 12.6943 15.0398 12.6941C15.0401 12.6939 15.0403 12.6936 15.0406 12.6933C15.0412 12.6928 15.0418 12.6922 15.0424 12.6915C15.0437 12.6902 15.0452 12.6886 15.0469 12.6869C15.0502 12.6835 15.0543 12.6792 15.0591 12.6741C15.0686 12.664 15.0808 12.6506 15.0954 12.634C15.1245 12.6007 15.163 12.5544 15.2076 12.495C15.2967 12.3762 15.4107 12.2045 15.5233 11.9796C15.7491 11.5282 15.9666 10.8668 15.9666 9.99996H14.9666Z"
      fill="url(#paint0_linear_1095_21562)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1095_21562"
        x1="15.4666"
        y1="5.3175"
        x2="4.08338"
        y2="8.73775"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E0004D" />
        <stop offset="1" stopColor="#EA27C2" />
      </linearGradient>
    </defs>
  </svg>
);

export const RemainBalanceRightArrow = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.2">
      <path
        d="M9 18L15 12L9 6"
        stroke="black"
        strokeWidth="1.75"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const SandiCI = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="93"
    height="22"
    viewBox="0 0 268 60"
    fill="none"
  >
    <mask
      id="mask0_1102_23792"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="253"
      y="3"
      width="15"
      height="54"
    >
      <path d="M268 3.11084H253.347V56.8735H268V3.11084Z" fill="white" />
    </mask>
    <g mask="url(#mask0_1102_23792)">
      <path d="M268 3.11084H253.347V56.8735H268V3.11084Z" fill="#EA27C2" />
    </g>
    <mask
      id="mask1_1102_23792"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="191"
      y="3"
      width="57"
      height="54"
    >
      <path
        d="M206.086 15.3304H220.741C228.834 15.3304 232.896 21.8978 232.896 29.9952C232.896 38.0926 228.834 44.6569 220.741 44.6569H206.086V15.3304ZM206.086 3.11084H191.433V56.8735H206.086L223.173 56.8945C238.014 56.8945 247.549 44.8549 247.549 30.0042C247.549 15.1534 238.014 3.11084 223.173 3.11084H206.086Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_1102_23792)">
      <path
        d="M247.549 3.11084H191.433V56.8945H247.549V3.11084Z"
        fill="#EA27C2"
      />
    </g>
    <mask
      id="mask2_1102_23792"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="124"
      y="3"
      width="59"
      height="54"
    >
      <path
        d="M168.002 3.11084V54.7854H167.432L153.349 3.11084H124.041V56.8735H138.697V5.21395H139.266L153.349 56.8735H182.654V3.11084H168.002Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2_1102_23792)">
      <path
        d="M182.654 3.11084H124.041V56.8735H182.654V3.11084Z"
        fill="#EA27C2"
      />
    </g>
    <mask
      id="mask3_1102_23792"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="59"
      y="3"
      width="60"
      height="54"
    >
      <path
        d="M74.0602 3.11084L59.4077 56.8735H74.0602L88.1401 5.21395H89.2884L103.368 56.8735H118.021L103.368 3.11084H74.0602Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask3_1102_23792)">
      <path
        d="M118.021 3.11084H59.4077V56.8735H118.021V3.11084Z"
        fill="#EA27C2"
      />
    </g>
    <mask
      id="mask4_1102_23792"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="57"
      height="35"
    >
      <path
        d="M0 18.6609C0 25.3962 5.3639 31.2915 13.4023 34.5737V15.3398H42.7073V19.441H56.0856C56.1006 19.1799 56.1125 18.9219 56.1125 18.6609C56.1125 8.35241 43.5528 0 28.0548 0C12.5567 0 0 8.35241 0 18.6609Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask4_1102_23792)">
      <path d="M56.1125 0H0V34.5737H56.1125V0Z" fill="#EA27C2" />
    </g>
    <mask
      id="mask5_1102_23792"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="25"
      width="57"
      height="35"
    >
      <path
        d="M42.7073 44.6573H13.4023V40.5591H0.0239861C0.0089948 40.8171 0 41.0751 0 41.3391C0 51.6446 12.5597 60 28.0548 60C43.5498 60 56.1125 51.6446 56.1125 41.3391C56.1125 34.6038 50.7457 28.7055 42.7073 25.4233V44.6573Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask5_1102_23792)">
      <path d="M56.1125 25.4233H0V60H56.1125V25.4233Z" fill="#EA27C2" />
    </g>
  </svg>
);

export const HomeBuildingInfoIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.47228 2.05078V1.30078H2.72228V2.05078H3.47228ZM20.5279 2.05078H21.2779V1.30078H20.5279V2.05078ZM9.15747 16.2638V15.5138H8.40747V16.2638H9.15747ZM14.8427 16.2638H15.5927V15.5138H14.8427V16.2638ZM1.34033 22.699H22.6598V21.199H1.34033V22.699ZM12.0001 1.30078H3.47228V2.80078H12.0001V1.30078ZM20.5279 1.30078H12.0001V2.80078H20.5279V1.30078ZM2.72228 2.05078V21.949H4.22228V2.05078H2.72228ZM19.7779 2.05078V21.949H21.2779V2.05078H19.7779ZM9.90747 21.949V16.2638H8.40747V21.949H9.90747ZM9.15747 17.0138H14.8427V15.5138H9.15747V17.0138ZM14.0927 16.2638V21.949H15.5927V16.2638H14.0927Z"
      fill="black"
    />
    <path
      d="M8.46821 7.55664H15.5975M8.40234 11.6386H15.5316"
      stroke="url(#paint0_linear_4610_46334)"
      strokeWidth="1.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4610_46334"
        x1="15.5975"
        y1="7.55664"
        x2="8.82375"
        y2="10.6296"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EA27C2" />
        <stop offset="1" stopColor="#E100A3" />
      </linearGradient>
    </defs>
  </svg>
);
